import React from 'react';
import { FlagId } from '../../models/communication.types';
import { FlagIcon } from '../SystemSettings/SystemFlags/Subcomponents/FlagIcon.component';
import { getMessageFlagLabel } from './MessagesList/utils';

export interface MessageFlagProps {
  flagId: FlagId;
}

const MessageFlag: React.FC<MessageFlagProps> = ({ flagId }) => {
  const flagData = getMessageFlagLabel(flagId);
  return <FlagIcon id={flagId} name={flagData.letter} color={flagData.color} />;
};

export default MessageFlag;
